define((require) => {
    "use strict";

    var DashboardSorting                        = require("ui/dashboard/DashboardSorting"),
        DeleteExperienceAction                  = require("ui/actions/DeleteExperienceAction"),
        DeleteGroupAction                       = require("ui/actions/DeleteGroupAction"),
        DuplicateExperienceAction               = require("editor/ui/actions/DuplicateExperienceAction"),
        DuplicateExperiencePermissionsAction    = require("editor/ui/actions/DuplicateExperiencePermissionsAction"),
        DuplicateGroupAction                    = require("ui/actions/DuplicateGroupAction"),
        GroupModel                              = require("shared/ui/groups/GroupModel"),
        Preconditions                           = require("shared/util/Preconditions"),
        Promise                                 = require("shared/util/Promise"),
        SystemMessages                          = require("editor/services/SystemMessages"),
        ViewController                          = require("editor/util/ViewController");

    /**
     *
     * @class DashboardContentCollectionViewController
     * @see  DashboardContentCollectionView
     */
    return ViewController.extend({

        /**
         * Invoked when the user activates the quick view.
         *
         * Creates the options object passed to the <tt>QuickView</tt> and starts fetching the experience
         * data. A <tt>promise</tt> property is exposed that will be resolved once
         * all data has been fetched.
         *
         * @param  {ExperienceModel|GroupModel} model The associated experience model.
         */
        onViewQuickViewOpen: function(model) {
            var options = {
                model:          model,
                spectatorMode:  this.options.spectatorMode,
                isEditable:     !this.options.spectatorMode,
                projectContext: this.options.projectContext,
                promise:        Promise.resolved()
            };

            var initialExperience = model;

            // TODO: Re-write quickview to proper support both groups and experiences...
            if (model instanceof GroupModel) {
                options.group = model;
                options.model = model.getUniqueEntries()[0][0];

                initialExperience = options.model;
            }

            options.promise = initialExperience.fetchAll();

            this.view.openQuickView(options);
        },

        onViewDuplicate: function(model) {
            var view = this.view,
                ActionClass = model instanceof GroupModel ? DuplicateGroupAction : DuplicateExperienceAction,
                action = new ActionClass(model, {postfix: "new", projectContext: this.options.projectContext});

            if (!action.executable()) {
                return;
            }

            action.execute()
                .then((clone) => {
                    const experiencePermissionsAction = new DuplicateExperiencePermissionsAction(model, clone);
                    if (experiencePermissionsAction.executable()) {
                        return experiencePermissionsAction.execute();
                    }
                })
                .then(() => {
                    // HACK: Since the client no longer knows the sorting layout algorithm, we need to refresh the
                    // dashboard by setting the sorting to "Last Updated" - this also ensures that the user will always
                    // see the newly duplicated experience/group...
                    view.refresh(DashboardSorting.MONTH);
                });
        },

        onViewDelete: function(model) {
            var ActionClass = model instanceof GroupModel ? DeleteGroupAction : DeleteExperienceAction,
                projectContext = this.options.projectContext,
                project = this.options.projectContext && this.options.projectContext.project,
                action = new ActionClass(model, project),
                collection = this.view.collection,
                modelTypeText = model.get("type") !== "Experience" ? "Group" : "Experience"; // Simplify type for user messages. See MOS-1994.

            if (!action.executable()) {
                Preconditions.warn("tried to delete '" + model.get("name") + "' (" + model.id + "), but the action is not executable");
                return;
            }

            action.execute().then((model) => {
                // If removal/destruction was successful - remove it from the current collection (this will also remove it from the view)
                collection.remove(model);

                // Notify user on successful delete
                SystemMessages.notifyPurge(modelTypeText, "deleted", null, false);

                // Sync project model, if any...
                if (projectContext) {
                    return project.fetch();
                }
            });
        }


    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/DashboardContentCollectionViewController.js